import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/shape1.png'
import _imports_1 from '../../assets/img/shape2.svg'
import _imports_2 from '../../assets/img/shape3.svg'
import _imports_3 from '../../assets/img/shape4.svg'
import _imports_4 from '../../assets/img/shape5.png'


const _hoisted_1 = { class: "agency-services-area ptb-80" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-6 m-auto" }
const _hoisted_5 = { class: "card p-5" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = ["disabled"]

import { computed, ref } from 'vue';
import { useAuthStore } from '../../store/user';
import { useRouter } from 'vue-router';
import { useNotificationStore } from '../../store/notif';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  setup(__props) {

const ustore = useAuthStore()
const nstore = useNotificationStore()
const router = useRouter()
const email = ref("");
const password =  ref("")


const isDisabled = computed(() =>{
    if (email.value=="" || password.value=="") {
        return true
    } else {
        return false
    }
})

const login = async () =>{

   try {
    await ustore.login(email.value,password.value)
    router.push('/')
   } catch (error) {
    nstore.successNotif("Bienvenue")

   }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"page-title-area\"><div class=\"d-table\"><div class=\"d-table-cell\"><div class=\"container\"><h2>Connection</h2></div></div></div><div class=\"shape1\"><img src=\"" + _imports_0 + "\" alt=\"shape\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"shape\"></div><div class=\"shape3\"><img src=\"" + _imports_2 + "\" alt=\"shape\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"shape\"></div><div class=\"shape5\"><img src=\"" + _imports_4 + "\" alt=\"shape\"></div><div class=\"shape6 rotateme\"><img src=\"" + _imports_3 + "\" alt=\"shape\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"shape\"></div><div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"shape\"></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  for: "",
                  class: "form-label"
                }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  name: "",
                  id: "",
                  "aria-describedby": "emailHelpId",
                  placeholder: "abc@mail.com",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
                }, null, 512), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  for: "",
                  class: "form-label"
                }, "Mot de passe", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  name: "",
                  id: "",
                  placeholder: "****",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
                }, null, 512), [
                  [_vModelText, password.value]
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: isDisabled.value,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (login()))
              }, " Save ", 8, _hoisted_8)
            ])
          ])
        ])
      ]),
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"shape\"></div><div class=\"shape3\"><img src=\"" + _imports_2 + "\" alt=\"shape\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"shape\"></div><div class=\"shape6 rotateme\"><img src=\"" + _imports_3 + "\" alt=\"shape\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"shape\"></div><div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"shape\"></div>", 6))
    ])
  ]))
}
}

})